// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"237":"ceae7349","880":"6f1a02a9"}[chunkId] + ".js";
};